const PATTERN = /^[A-Za-z0-9 ]{1,11}$/

export default function validateSenderName(senderName) {
  return PATTERN.test(senderName)
}
